export enum LienType {
  STATE = 'State', FEDERAL = 'Federal', HOA = 'HOA', MISC = 'Misc'
} 